"use client";

import { motion } from "motion/react";
import { ArrowUpRight } from "lucide-react";
import React from "react";

const CHANNELS = [
    { label: "Email", value: "contact@hamidayub.com", href: "mailto:contact@hamidayub.com" },
    { label: "LinkedIn", value: "Hamid Ayub", href: "https://www.linkedin.com/in/hamid-ayub/" },
    { label: "Twitter", value: "@HaMi_Ayub", href: "https://twitter.com/HaMi_Ayub" },
];

export function ExecutiveDetails() {
    return (
        <section className="py-24 border-t border-white/5 bg-black/50 backdrop-blur-3xl z-10 relative">
            <div className="container mx-auto px-6 max-w-6xl">
                <div className="grid md:grid-cols-2 gap-16 md:gap-24">
                    
                    {/* Left: Contact Channels */}
                    <div className="space-y-12">
                        <h3 className="text-xl text-white font-medium">Direct Channels</h3>
                        <div className="space-y-6">
                            {CHANNELS.map((channel, i) => (
                                <motion.a
                                    key={channel.label}
                                    href={channel.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: i * 0.1, duration: 0.5 }}
                                    className="group flex justify-between items-center py-4 border-b border-white/10 hover:border-white/40 transition-colors"
                                >
                                    <span className="text-slate-400 group-hover:text-white transition-colors">
                                        {channel.label}
                                    </span>
                                    <div className="flex items-center gap-2">
                                        <span className="text-white text-lg font-light">
                                            {channel.value}
                                        </span>
                                        <ArrowUpRight className="w-4 h-4 text-slate-600 group-hover:text-white transition-colors" />
                                    </div>
                                </motion.a>
                            ))}
                        </div>
                    </div>

                    {/* Right: Brief Guidelines */}
                    <div className="space-y-12">
                        <h3 className="text-xl text-white font-medium">Engagement Guidelines</h3>
                        <div className="space-y-8">
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5 }}
                            >
                                <h4 className="text-slate-300 mb-2">Project Timelines</h4>
                                <p className="text-slate-500 font-light leading-relaxed">
                                    Initial discovery sessions are scheduled within 48 hours. Strategic engagements typically begin seamlessly within 2 weeks of our opening dialogue.
                                </p>
                            </motion.div>
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.1, duration: 0.5 }}
                            >
                                <h4 className="text-slate-300 mb-2">Partnership Model</h4>
                                <p className="text-slate-500 font-light leading-relaxed">
                                    I partner exclusively with organizations that value clear communication and high-impact execution. Milestones are established to ensure alignment from day one.
                                </p>
                            </motion.div>
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.2, duration: 0.5 }}
                            >
                                <h4 className="text-slate-300 mb-2">Global Reach</h4>
                                <p className="text-slate-500 font-light leading-relaxed">
                                    Based in Lahore (UTC+5), I coordinate asynchronously with clients globally, ensuring rapid progress across timezones without friction.
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
